import * as rtk from "@reduxjs/toolkit";
import "../state/reducers.js";
import "../state/actions.js";
import { beforeAuthenticationSuccess, getAccountPortalState, updateLegacyUserWithSession } from "../state/utils.js";
import { getReduxStore } from "../store/state/redux-host.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import { revokeAuthToken } from "./api-authn.js";
import { subscriptionApi } from "./api-subscription.js";
import { instanaSessionEventAuthn } from "./monitoring.js";
const dispatch = (action) => getReduxStore().dispatch(action);
const updateAuthnData = (authNData) => {
  dispatch(updateAuthNDataAction(authNData));
};
const onAuthenticationSuccess = async (user, isReauth) => {
  user.session.isReauthenticated = isReauth;
  await beforeAuthenticationSuccess.emit(user);
  dispatch(authenticationSuccessAction(user));
};
const logoutAuthnUser = async () => {
  await dispatch(logoutAuthnUserAction());
};
const { createAction, createAsyncThunk } = { ...rtk }.default || rtk;
const updateAuthNDataAction = createAction("account/updateAuthNDataAction");
const authenticationSuccessAction = createAction("account/authenticationSuccessAction");
const logoutAuthnUserAction = createAsyncThunk("account/logoutAuthnUserAction", async () => {
  return revokeAuthToken();
});
const updateUserState = (state, user) => {
  state.eventType = getAuthEvent(user);
  state.status = "success";
  state.isAuthenticated = true;
  user = updateLegacyUserWithSession(user);
  state.user = user;
  state.isPersistent = user.session.isPersistent;
  state.isSessionReload = user.session.isSessionReload;
  state.isReauthenticated = user.session.isReauthenticated;
  instanaSessionEventAuthn(user);
};
const subscriptionApiAction = createAsyncThunk(
  "account/lightRegistration",
  (data, { rejectWithValue }) => {
    return subscriptionApi.subscribeUser(data).catch(rejectWithValue);
  }
);
function addAuthnApiReducers(builder) {
  return builder.addCase(updateAuthNDataAction, (state, { payload }) => {
    updateUserState(state, payload);
  }).addCase(authenticationSuccessAction, (state, { payload }) => {
    updateUserState(state, payload);
  }).addCase(logoutAuthnUserAction.pending, (state) => {
    state.eventType = "logout";
    state.status = "pending";
    delete state.error;
  }).addCase(logoutAuthnUserAction.fulfilled, (state) => {
    state.eventType = "logout";
    state.status = "success";
    state.isAuthenticated = false;
    delete state.user;
    delete state.isPersistent;
    delete state.authContext;
    delete state.kmc;
    delete state.lightUser;
    delete state.profileData;
    delete state.error;
  });
}
function getAuthEvent(user) {
  const { session } = updateLegacyUserWithSession(user);
  if (session.isSessionReload) {
    return "sessionReload";
  } else if (session.socialProvider) {
    return "externalAuth";
  } else if (session.isNewUser) {
    return "registration";
  } else {
    return "login";
  }
}
const subscribeUser = async (data) => {
  await dispatch(subscriptionApiAction(data));
  const { lightUser, error } = getAccountPortalState() || {};
  return lightUser ? Promise.resolve(lightUser) : Promise.reject(error);
};
export {
  addAuthnApiReducers,
  getAuthEvent,
  logoutAuthnUser,
  onAuthenticationSuccess,
  subscribeUser,
  subscriptionApiAction,
  updateAuthnData
};
//# sourceMappingURL=state.js.map
